import { useRootStore } from '~/store/root'
import { useApplicationConfigStore } from '~/store/application-config'
import { useContactGuestStore } from '~/store/contact-guest'
import { useDealsStore } from '~/store/deals'
import appConstants from '~/libs/constants/application-constants.js'

const { nuxtBaseUrl } = appConstants

export default defineNuxtRouteMiddleware(async (to) => {
  const { $lendioCookies } = useNuxtApp()
  const rootStore = useRootStore()
  const dealsStore = useDealsStore()
  const appConfigStore = useApplicationConfigStore()
  const contactGuestStore = useContactGuestStore()
  try {
    const authType = to.params.authType

    if (authType === 'contact-guest') {
      contactGuestStore.loadTokenFromCookies()

      if (!contactGuestStore.token) {
        console.warn('Contact Guest route middleware: token not set.')
        return navigateTo('/guest/additional-owner/post-offer-docs')
      }

      const res = await contactGuestStore.getContactPostOfferDocumentModules()
      if (res?.error) {
        console.error('Error fetching contact guest modules:', res.error)
        return navigateTo('/guest/additional-owner/post-offer-docs')
      }
      return
    }

    const token = to.query?.token || $lendioCookies.get('documentUploadRequestInviteToken')
    const isLoggedIn = rootStore.isLoggedIn
    const unauthorized = (authType === 'invite' && !token) || (authType === 'borrower' && !isLoggedIn)

    if (!['borrower', 'invite'].includes(authType) || unauthorized) {
      redirectToWidget(to.fullPath)
      return
    }

    if (isLoggedIn) {
      await dealsStore.getDealsWithOffers()
    } else if (token) {
      try {
        const expiration = JSON.parse(atob(token.split('.')[1])).exp
        if (Date.now() / 1000 > expiration) {
          $lendioCookies.remove('documentUploadRequestInviteToken', { path: `${nuxtBaseUrl}/` })
          return navigateTo('/document-upload-request/invite-expired')
        } else {
          $lendioCookies.set('documentUploadRequestInviteToken', token, { path: `${nuxtBaseUrl}/`, expires: 30 * 24 * 60 * 60 })
        }
      } catch (e) {
        redirectToWidget(to.fullPath)
        return
      }
    }

    await appConfigStore.getDocumentUploadRequestApplicationConfig(isLoggedIn ? null : token, false, isLoggedIn ? dealsStore.activeDeal?.id : null)
  } catch (e) {
    console.error(e)
    redirectToWidget(to.fullPath)
    return
  }
})
